import type { ConnectedProjectDto } from "@/api/types";
import { routes } from "@/routes";

import type { ProductUpdateAction } from "./productUpdates";

export function getProductUpdateCreateMessagePath(projectSlug?: string): string {
  return projectSlug
    ? routes.communityFeed.adminCreatePost({ slug: projectSlug })
    : routes.portfolio.createMassMessage();
}

/**
 * Routes creation actions to the selected project or portfolio, and ticket actions to the unfiltered portfolio list.
 * Returns undefined for translation settings, which are opened without route navigation.
 */
export function getProductUpdateActionPath(action: ProductUpdateAction, projectSlug?: string): string | undefined {
  switch (action) {
    case "create-community-poll":
    case "create-community-post":
    case "create-home-announcement":
      return getProductUpdateCreateMessagePath(projectSlug);
    case "view-portfolio-tickets":
      return routes.portfolio.tickets();
    case "manage-alerts":
      return routes.alerts.settings();
    case "review-auto-translation-settings":
      return undefined;
  }
}

/**
 * Matches the portfolio ticket navigation's audience: at least one project with a role other than resident or
 * service partner, including users with just one admin project.
 */
export function canViewPortfolioTicketUpdate(projects: readonly Pick<ConnectedProjectDto, "userRole">[]): boolean {
  return hasPortfolioAdminProject(projects);
}

/** Matches the alert navigation's audience: at least one project with a role other than resident or service partner. */
export function canViewAlertManagementUpdate(projects: readonly Pick<ConnectedProjectDto, "userRole">[]): boolean {
  return hasPortfolioAdminProject(projects);
}

function hasPortfolioAdminProject(projects: readonly Pick<ConnectedProjectDto, "userRole">[]): boolean {
  return projects.some((project) => project.userRole !== "resident" && project.userRole !== "servicePartner");
}
